import { render, staticRenderFns } from "./QbExamCourseSemesterProclaimed.vue?vue&type=template&id=1c51eef1&"
import script from "./QbExamCourseSemesterProclaimed.vue?vue&type=script&lang=js&"
export * from "./QbExamCourseSemesterProclaimed.vue?vue&type=script&lang=js&"
import style0 from "./QbExamCourseSemesterProclaimed.vue?vue&type=style&index=0&id=1c51eef1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports